import React, { useState, useRef, useEffect } from "react";
import "./style.css";
import Tabs from "../../masterplan/filter/tabs";
import SearchFilter from "../../masterplan/filter/searchFilter";
import Range from "../../masterplan/filter/range";
import FilterMasterVillas from "./FilterMasterVillas";
import { useZone } from "../../../context/ZoneContext";
import { useFilterContext } from "../../../context/FilterContext";
function FilterMaster({ isOpen, lang, setProgressVilla, setSpinVilla }) {
  const { units, loading } = useZone();
  const { filteredUnits } = useFilterContext();

  const [showVillasOverlay, setShowVillasOverlay] = useState(false);
  const filterContainerRef = useRef(null);

  const handleShowOverlay = (shouldShow) => {
    setShowVillasOverlay(shouldShow);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!isOpen) return;

      const clickedInsideFilter = filterContainerRef.current?.contains(
        event.target
      );
      if (!clickedInsideFilter) {
        setShowVillasOverlay(false);
        return;
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, showVillasOverlay]);

  if (loading) return <div>Loading...</div>;

  return (
    // <div
    //   ref={filterContainerRef}
    //   className={`filter-master-collapse col-10 col-md-5 ${isOpen ? "open" : ""}`}
    //   style={{
    //     // maxHeight: isOpen ? "100vh" : "0",
    //     overflow: showVillasOverlay ? "visible" : "hidden",
    //     transition: "max-height 0.6s ease-in-out, overflow 0s 0.6s",
    //   }}
    // >
    <div
      ref={filterContainerRef}
      /* الـ Logic يعتمد الآن على كلاس open اللي أنت ظبطت الـ CSS بتاعه */
      className={`filter-master-collapse col-10 col-md-5 ${isOpen ? "open" : ""}`}
      style={{
        /* 1. تفعيل الـ maxHeight برمجياً لضمان الانتقال السلس */
        maxHeight: isOpen ? "100vh" : "0", 
        
        /* 2. تحسين الـ overflow ليسمح بظهور المحتوى فقط عند الفتح */
        overflowY: isOpen ? (showVillasOverlay ? "visible" : "auto") : "hidden",
        
        /* 3. تنظيف الـ transition وكتابته بشكل صحيح */
        transition: "max-height 0.6s ease-in-out"
      }}
    >
      <div className="filter-master-content">
        <SearchFilter
          mode="master"
          onToggleMenu={handleShowOverlay}
          inMasterFilter={true}
        />
        <div className="col-12">
          <Tabs lang={lang} />
        </div>
        <div className="col-12 mb-4">
          <Range units={units} />
        </div>
      </div>

      {showVillasOverlay && (
        <FilterMasterVillas
          units={filteredUnits}
          closeOverlay={() => handleShowOverlay(false)}
          setProgressVilla={setProgressVilla}
          setSpinVilla={setSpinVilla}
        />
      )}
    </div>
  );
}

export default FilterMaster;
